import "./AdditionalServices.module.css";
import Header from "@/reusable_sections/Header";
import AktenvernichtungVorOrt from "./sections/AktenvernichtungVorOrt";
import RegionalObjectServices from "./sections/RegionalObjectServices";
import Footer from "@/reusable_sections/Footer";
export default function AdditionalServicesPage() {
  return <div>
      <Header />
      <AktenvernichtungVorOrt />
      <RegionalObjectServices />
      <Footer />
    </div>;
}